import QianniuAppDetect from '../common/qianniu-pc-app-detect';

export default (X) => {

  let doc = document;

  let app = {
    invoke(options) {
      // To support api alias, we need to get api info from api map.
      let api = X.getApiByAlias(options.api);
      options.api = api || {
        type: X.API_TYPE.QN_APP,
        uri: options.api,
      };

      return X.call(options);
    },

    name: QianniuAppDetect.isQianniu ? 'qianniu' : 'web',
  };

  return app;
}



// WEBPACK FOOTER //
// ./src/plugins/qianniu-pc-app.js